import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { DESKTOP_EXTRA_SMALL_WIDTH, DESKTOP_WIDTH } from 'Styles/variables/sizes';

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    grid-template-columns: 1fr;
    > div:first-child {
      order: 2;
    }
    > div:nth-child(3) {
      order: 3;
    }
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    grid-template-columns: 2fr;
    > aside {
      display: none;
    }
    > div:first-child {
      order: 2;
    }
    > div:nth-child(3) {
      order: 3;
    }
  }
`;

export const BannersContainer = styled(FlexContainer)`
  @media screen and (max-width: ${DESKTOP_EXTRA_SMALL_WIDTH}) {
    display: none;
  }
`;
